"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var matchmediaquery_1 = __importDefault(require("matchmediaquery"));
var hyphenate_style_name_1 = __importDefault(require("hyphenate-style-name"));
var shallow_equal_1 = require("shallow-equal");
var toQuery_1 = __importDefault(require("./toQuery"));
var Context_1 = __importDefault(require("./Context"));
var makeQuery = function (settings) { return settings.query || (0, toQuery_1.default)(settings); };
var hyphenateKeys = function (obj) {
    if (!obj)
        return undefined;
    var keys = Object.keys(obj);
    return keys.reduce(function (result, key) {
        result[(0, hyphenate_style_name_1.default)(key)] = obj[key];
        return result;
    }, {});
};
var useIsUpdate = function () {
    var ref = react_1.default.useRef(false);
    react_1.default.useEffect(function () {
        ref.current = true;
    }, []);
    return ref.current;
};
var useDevice = function (deviceFromProps) {
    var deviceFromContext = react_1.default.useContext(Context_1.default);
    var getDevice = function () {
        return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
    };
    var _a = react_1.default.useState(getDevice), device = _a[0], setDevice = _a[1];
    react_1.default.useEffect(function () {
        var newDevice = getDevice();
        if (!(0, shallow_equal_1.shallowEqualObjects)(device, newDevice)) {
            setDevice(newDevice);
        }
    }, [deviceFromProps, deviceFromContext]);
    return device;
};
var useQuery = function (settings) {
    var getQuery = function () { return makeQuery(settings); };
    var _a = react_1.default.useState(getQuery), query = _a[0], setQuery = _a[1];
    react_1.default.useEffect(function () {
        var newQuery = getQuery();
        if (query !== newQuery) {
            setQuery(newQuery);
        }
    }, [settings]);
    return query;
};
var useMatchMedia = function (query, device) {
    var getMatchMedia = function () { return (0, matchmediaquery_1.default)(query, device || {}, !!device); };
    var _a = react_1.default.useState(getMatchMedia), mq = _a[0], setMq = _a[1];
    var isUpdate = useIsUpdate();
    react_1.default.useEffect(function () {
        if (isUpdate) {
            // skip on mounting, it has already been set
            var newMq_1 = getMatchMedia();
            setMq(newMq_1);
            return function () {
                if (newMq_1) {
                    newMq_1.dispose();
                }
            };
        }
    }, [query, device]);
    return mq;
};
var useMatches = function (mediaQuery) {
    var _a = react_1.default.useState(mediaQuery.matches), matches = _a[0], setMatches = _a[1];
    react_1.default.useEffect(function () {
        var updateMatches = function () {
            setMatches(mediaQuery.matches);
        };
        mediaQuery.addListener(updateMatches);
        updateMatches();
        return function () {
            mediaQuery.removeListener(updateMatches);
        };
    }, [mediaQuery]);
    return matches;
};
var useMediaQuery = function (settings, device, onChange) {
    var deviceSettings = useDevice(device);
    var query = useQuery(settings);
    if (!query)
        throw new Error('Invalid or missing MediaQuery!');
    var mq = useMatchMedia(query, deviceSettings);
    var matches = useMatches(mq);
    var isUpdate = useIsUpdate();
    react_1.default.useEffect(function () {
        if (isUpdate && onChange) {
            onChange(matches);
        }
    }, [matches]);
    react_1.default.useEffect(function () { return function () {
        if (mq) {
            mq.dispose();
        }
    }; }, []);
    return matches;
};
exports.default = useMediaQuery;



//////////////////
// WEBPACK FOOTER
// ./src/useMediaQuery.ts
// module id = 0
// module chunks = 0